import React from "react";
import Header from "../../components/Header/Header";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import Footer from "../../components/Footer/Footer";
import { useTranslation } from "react-i18next";
import s from "./InvestmentProductPassort.module.scss";
import { DownloadOutlined, FilePdfOutlined } from "@ant-design/icons";

const InvestmentProductPassport = () => {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  const downloadFile = async (id) => {
    if (id === 1) {
      const fileUrl = "/Паспорт продукта_Инвестиционное финансирование.pdf";
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "/Паспорт продукта_Инвестиционное финансирование.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    if (id === 2) {
      const fileUrl =
        "/assets/appendix/Паспорт продукта_Долговое финансирование.pdf";
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "/Паспорт продукта_Долговое финансирование.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    if (id === 3) {
      const fileUrl =
        "/assets/appendix/Паспорт продукта_Финансирование логистических центров.pdf";
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download =
        "/Паспорт продукта_Финансирование логистических центров.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const openFileInNewWindow = (e, file) => {
    e.preventDefault();
    const fileUrl = file;
    window.open(fileUrl, "_blank");
  };
  return (
    <div>
      {width > 970 ? <Header /> : <MobileHeader />}
      <div className={s.content}>
        <h2 className={s.h2}> {t("InvestmentFinancingProductPassport")}</h2>
        <div>
          <div className={s.documents_item}>
            <button
              className={s.title}
              onClick={(e) =>
                openFileInNewWindow(
                  e,
                  "/Паспорт продукта_Инвестиционное финансирование.pdf",
                )
              }
            >
              <FilePdfOutlined className={s.icon} /> &nbsp;
              {t("Паспорт продукта инвестиционного финансирования")}
            </button>
            <div className={s.btn} onClick={() => downloadFile(1)}>
              <DownloadOutlined />
            </div>
          </div>
          <div className={s.documents_item}>
            <button
              className={s.title}
              onClick={(e) =>
                openFileInNewWindow(
                  e,
                  "/assets/appendix/Паспорт продукта_Долговое финансирование.pdf",
                )
              }
            >
              <FilePdfOutlined className={s.icon} /> &nbsp;
              {t("Паспорт продукта долговое финансирование")}
            </button>
            <div className={s.btn} onClick={() => downloadFile(2)}>
              <DownloadOutlined />
            </div>
          </div>
          <div className={s.documents_item}>
            <button
              className={s.title}
              onClick={(e) =>
                openFileInNewWindow(
                  e,
                  "/assets/appendix/Паспорт продукта_Финансирование логистических центров.pdf",
                )
              }
            >
              <FilePdfOutlined className={s.icon} /> &nbsp;
              {t("Паспорт продукта финансирование логистических центров")}
            </button>
            <div className={s.btn} onClick={() => downloadFile(3)}>
              <DownloadOutlined />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default InvestmentProductPassport;
